module.exports = __webpack_public_path__ + "img/grid_item-v2.58d26ce9.svg";